module.exports = __webpack_public_path__ + "d6e9707897f19511a145fbc9042dcec4.fbx";